import { useNavigate } from 'react-router-dom'

export const PRINTER_URL = '/printer'

export const useGoToPrinter = () => {
  const navigate = useNavigate()

  return {
    go: () => {
      navigate(PRINTER_URL)
    }
  }
}
